





















































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import ModalHeader from "@/components/ModalHeader.vue";
import GapEditor from "@/components/gap/GapEditor.vue";
import GapLog from "@/components/gap/GapLog.vue";
import PatientEditor from "@/components/patient/PatientEditor.vue";
import { parsePhoneNumberFromString } from "libphonenumber-js";

@Component({
  components: {
    ModalHeader,
    GapEditor,
    GapLog,
    PatientEditor
  },
  filters: {
    phone: function(phone: string) {
      if (!phone) return null;
      const parsed = parsePhoneNumberFromString(phone, "US");
      if (parsed) return parsed.formatNational();
      return phone;
    }
  }
})
export default class NotifDetail extends Vue {
  @Prop() readonly batch!: any;
  @Prop(String) readonly toPhone!: string;
  items: Array<any> = [];
  providers: Array<any> = [];
  gapTemplateText: string = "";
  providerTemplateText: string = "";
  selected: any | null = null;
  async getGaps() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const { batchId } = this.batch;
      const { toPhone } = this;
      this.items = await this.$store.dispatch("notifs/getGaps", {
        batchId,
        toPhone
      });
      if (this.items.length) {
        this.getGapTemplateText();
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async getProviders() {
    try {
      const { batchId } = this.batch;
      const { toPhone } = this;
      this.providers = await this.$store.dispatch("notifs/getProviders", {
        batchId,
        toPhone
      });
      if (this.providers.length) {
        this.getProviderTemplateText();
      }
    } catch (error) {
      console.log(error);
    }
  }
  async getGapTemplateText() {
    try {
      const { templateId } = this.batch;
      const { id } = this.items[0];
      const action =
        this.batch.messageType === "VOICE"
          ? "getGapVoicePreviewText"
          : "getGapSMSPreview";
      this.gapTemplateText = await this.$store.dispatch("notifs/" + action, {
        gapId: id,
        templateId
      });
    } catch (err) {
      console.log(err);
    }
  }
  async getProviderTemplateText() {
    try {
      const templateId = this.batch.providerTemplateId;
      const provider = this.providers[0];
      const action =
        this.batch.messageType === "VOICE"
          ? "getProviderVoicePreviewText"
          : "getProviderSMSPreview";
      this.providerTemplateText = await this.$store.dispatch(
        "notifs/" + action,
        {
          provider,
          templateId
        }
      );
    } catch (err) {
      console.log(err);
    }
  }
  editPatient(gap) {
    this.selected = gap;
    this.$modal.show("patient-editor");
  }
  editGap(gap) {
    this.selected = gap;
    this.$modal.show("gap-editor");
  }
  showLog(gap) {
    this.selected = gap;
    this.$modal.show("gap-log");
  }
  get itemsSent() {
    return this.items.filter(item => {
      return item.messageSid !== null;
    }).length;
  }
  get itemsWithErrors() {
    return this.items.filter(item => {
      return item.messageSid === null;
    }).length;
  }
  mounted() {
    this.getGaps();
    this.getProviders();
  }
}
